import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            width: '100%',
            height: '100%',
            paddingTop: '50px',
            paddingRight: '40px',
            paddingBottom: '10px',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
        },
        paperR: {
            padding: '30px 24px 24px 24px',
            flex: '0 0 49%'
            //width: { xs: '59%', sm: '59%', md: '49%', lg: '49%', xl: '49%' }
        },
        paperL: {
            padding: '30px 24px 24px 24px',
            flex: '0 0 49%'
            //width: { xs: '39%', sm: '39%', md: '49%', lg: '49%', xl: '49%' }
        },
        constainerAction: {
            display: 'flex',
            columnGap: '12px',
            justifyContent: 'center',
        },
        edit: {
            padding: 0,
            color: colors.color10,
        },
        delete: {
            padding: 0,
            color: colors.color10,
        },
        containerPaper: {
            padding: 1,
            display: 'flex',
            //gap: 3,
            justifyContent: 'space-between',
            alignItems: 'stretch',
            //height: '90vh'
        }
    }
}

export { useStyles }
